export type OrderSide = 'Long' | 'Short';
export type OrderExecutionType = 'Market' | 'Limit' | 'Stop' | 'Range';
export type InputUnit = 'NATIVE' | 'USD';

// adding a type cos people will get error when trying to make it too small
export type minLimitOrderRange = 0.3 | 0.4 | 0.5 | 0.6 | 0.7 | 0.8 | 0.9 | 1;

export enum TradeStatus {
	Ok,
	InvalidPrice,
	InvalidOrderType,
	PriceOutOfBounds,
	CanLiquidate,
	CannotLiquidate,
	MaxMarketSizeExceeded,
	MaxLeverageExceeded,
	InsufficientMargin,
	NotPermitted,
	NilOrder,
	NoPositionOpen,
	PriceTooVolatile,
	PriceImpactToleranceExceeded
}

export type ActionType = 'openPosition' | 'closePosition';

export class PostTradeDetails {
	'fee': string;
	'liquidationPrice': string;
	'totalMargin': string;
	'accessibleMargin': string;
	'status': TradeStatus;
	'assetPrice': string;
	'keeperFee': string;
	'advancedOrderFixedFee': string;
	'advancedOrderOrderFee': string;
}

export class ShouldUpdateKeeperFee {
	'shouldUpdate': boolean;
	'gasCostToUpdateKeeperFeeInUsd': string;
	'minKeeperFeeFromDynamicGasModuleContractInUsd': string;
	'minKeeperFeeFromMarketSettingsContractInUsd': string;
}

export enum LimitStatus {
	Ok,
	InvalidTriggerAboveLimit,
	InvalidLimitAboveTrigger,
	PriceRangeTooSmall,
	NotValidOrder
}

export const invalidLimitOrderStatus = [
	TradeStatus.CanLiquidate,
	TradeStatus.MaxLeverageExceeded
	// TradeStatus.InsufficientMargin this will be checked in the UI itself.
];
